/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockOutboundDetailExportDto
 */
export interface StockOutboundDetailExportDto {
    /**
     * 
     * @type {string}
     * @memberof StockOutboundDetailExportDto
     */
    inOutTime?: string;
    /**
     * 
     * @type {string}
     * @memberof StockOutboundDetailExportDto
     */
    orderCode?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOutboundDetailExportDto
     */
    goodsId?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOutboundDetailExportDto
     */
    skuId?: string;
    /**
     * 
     * @type {string}
     * @memberof StockOutboundDetailExportDto
     */
    spuId?: string;
    /**
     * 
     * @type {string}
     * @memberof StockOutboundDetailExportDto
     */
    marketBarcode?: string;
    /**
     * 
     * @type {string}
     * @memberof StockOutboundDetailExportDto
     */
    marketProNm?: string;
    /**
     * 
     * @type {string}
     * @memberof StockOutboundDetailExportDto
     */
    marketOptionNm?: string;
    /**
     * 
     * @type {number}
     * @memberof StockOutboundDetailExportDto
     */
    skuNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof StockOutboundDetailExportDto
     */
    consNm?: string;
    /**
     * 
     * @type {string}
     * @memberof StockOutboundDetailExportDto
     */
    consAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof StockOutboundDetailExportDto
     */
    trkCnt?: string;
}

/**
 * Check if a given object implements the StockOutboundDetailExportDto interface.
 */
export function instanceOfStockOutboundDetailExportDto(value: object): value is StockOutboundDetailExportDto {
    return true;
}

export function StockOutboundDetailExportDtoFromJSON(json: any): StockOutboundDetailExportDto {
    return StockOutboundDetailExportDtoFromJSONTyped(json, false);
}

export function StockOutboundDetailExportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockOutboundDetailExportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'inOutTime': json['inOutTime'] == null ? undefined : json['inOutTime'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'spuId': json['spuId'] == null ? undefined : json['spuId'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionNm': json['marketOptionNm'] == null ? undefined : json['marketOptionNm'],
        'skuNumber': json['skuNumber'] == null ? undefined : json['skuNumber'],
        'consNm': json['consNm'] == null ? undefined : json['consNm'],
        'consAddress': json['consAddress'] == null ? undefined : json['consAddress'],
        'trkCnt': json['trkCnt'] == null ? undefined : json['trkCnt'],
    };
}

export function StockOutboundDetailExportDtoToJSON(json: any): StockOutboundDetailExportDto {
    return StockOutboundDetailExportDtoToJSONTyped(json, false);
}

export function StockOutboundDetailExportDtoToJSONTyped(value?: StockOutboundDetailExportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inOutTime': value['inOutTime'],
        'orderCode': value['orderCode'],
        'goodsId': value['goodsId'],
        'skuId': value['skuId'],
        'spuId': value['spuId'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'marketOptionNm': value['marketOptionNm'],
        'skuNumber': value['skuNumber'],
        'consNm': value['consNm'],
        'consAddress': value['consAddress'],
        'trkCnt': value['trkCnt'],
    };
}

